// 現在のステップを管理する変数
var currentTab = 0;

// 初期表示のための処理
document.addEventListener("DOMContentLoaded", function() {
  showTab(currentTab); // 最初のタブを表示

  // フォームが送信された際にsessionStorageをクリア
  document.getElementById('survey-form').addEventListener('submit', function(event) {
    clearStepLogs();
  });
});

// タブを表示する関数
function showTab(n) {
  var x = document.getElementsByClassName("tab");
  x[n].style.display = "block";
  if (n == 0) {
    clearStepLogs(); // 初回アクセス時にログをクリア
    saveStepLog(currentTab);
    document.getElementById("prevBtn").style.display = "none";
  } else {
    document.getElementById("prevBtn").style.display = "inline";
  }
  if (n == (x.length - 1)) {
    document.getElementById("submit-button").style.display = "inline";
    document.getElementById("next").style.display = "none";
  } else {
    document.getElementById("submit-button").style.display = "none";
    document.getElementById("next").style.display = "inline";
    document.getElementById("next").innerHTML = "次へ";
  }
  fixStepIndicator(n); // ステップインジケータの更新
}

// 次のステップへ進む、または前のステップに戻る関数
function nextPrev(n) {
  var x = document.getElementsByClassName("tab");

  if (n == 1 && !validateForm()) return false;

  // 現在のタブを隠す
  x[currentTab].style.display = "none";

  // 現在のタブのインデックスを変更
  currentTab = currentTab + n;

  // 次へボタンの場合ステップログを保存する（API呼び出し）
  if (n == 1) {
    saveStepLog(currentTab);
  }

  // 次のタブを表示
  showTab(currentTab);
  document.getElementById("inner-login").scrollIntoView(true);
}

// ステップインジケータを更新する関数
function fixStepIndicator(n) {
  var i, x = document.getElementsByClassName("step");
  for (i = 0; i < x.length; i++) {
    x[i].className = x[i].className.replace(" active", "");
  }
  x[n].className += " active";
}

// フォームのバリデーションを行う関数
function validateForm() {
  var tabs, inputs, selects, i, valid = true;
  var email_reg = /^[\w\*!#\$%&'\*\.\+\-\/=\?\^`\{\|}]{1,}@{1}[\w\*!#\$%&'\*\.\+\-\/=\?\^`\{\|}]{1,}\.[A-Za-z0-9]{1,}$/i;
  var password_reg = /^(?=.*?[a-z])(?=.*?[A-Z])(?=.*?\d)[\w\*!#%&'\*\.\+\-\/=\?\^`\{\|}]{8,100}$/;
  var japanese_reg = /[ぁ-んァ-ヶ一-龥]+?/;

  // 現在のタブにある入力と選択要素を取得
  tabs = document.getElementsByClassName("tab");
  inputs = tabs[currentTab].getElementsByTagName("input");
  selects = tabs[currentTab].getElementsByTagName("select");

  // 入力フィールドのバリデーション
  for (i = 0; i < inputs.length; i++) {
    if (inputs[i].value == "") {
      inputs[i].className += " invalid";
      inputs[i].parentElement.lastElementChild.innerHTML = "入力必須項目です";
      valid = false;
    } else {
      inputs[i].classList.remove('invalid');
      inputs[i].parentElement.lastElementChild.innerHTML = "";
    }

    // 直近の企業のバリデーション
    if (inputs[i].id == "previous_company_name" && !japanese_reg.test(inputs[i].value)) {
      inputs[i].className += " invalid";
      inputs[i].parentElement.lastElementChild.innerHTML = "正式な企業名を登録してください";
      valid = false;
    }

    // emailのバリデーション
    if (inputs[i].id == "email" && !email_reg.test(inputs[i].value)) {
      inputs[i].className += " invalid";
      inputs[i].parentElement.lastElementChild.innerHTML = "メールアドレスが正しくありません";
      valid = false;
    }

    // パスワードのバリデーション
    if (inputs[i].id == "applicant_password" && !password_reg.test(inputs[i].value)) {
      inputs[i].className += " invalid";
      inputs[i].parentElement.lastElementChild.innerHTML = "パスワードが正しくありません";
      valid = false;
    }

    // パスワード確認のバリデーション
    if (inputs[i].id == "applicant_password_confirmation" && inputs[i].value != document.getElementById('applicant_password').value) {
      inputs[i].className += " invalid";
      inputs[i].parentElement.lastElementChild.innerHTML = "パスワードが一致しません";
      valid = false;
    }
  }

  // 選択フィールドのバリデーション
  for (i = 0; i < selects.length; i++) {
    if (selects[i].value == "") {
      selects[i].className += " invalid";
      selects[i].parentElement.lastElementChild.innerHTML = "選択必須項目です";
      valid = false;
    } else {
      selects[i].classList.remove('invalid');
      selects[i].parentElement.lastElementChild.innerHTML = "";
    }
  }

  // すべてが正しい場合、進行状況を更新
  if (valid) {
    document.getElementsByClassName("step")[currentTab].className += " finish";
  }
  return valid;
}

// ステップごとにログを保存する関数
function saveStepLog(step) {
  try {
    // ログが既に送信されているか確認する
    if (sessionStorage.getItem('step_logged_' + step)) {
      return;
    }

    var csrfToken = document.querySelector('meta[name="csrf-token"]').getAttribute('content');

    fetch('/api/v1/access_logs', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-CSRF-Token': csrfToken // CSRFトークンの追加
      },
      body: JSON.stringify({
        access_log: {
          form_step: step,
          referer: document.referrer
        }
      })
    })
    .then(function(response) {
      if (!response.ok) {
        // ステータスコードがエラーのとき
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      return response.json();
    })
    .then(function(data) {
      // ログが保存されたステップをsessionStorageに記録
      sessionStorage.setItem('step_logged_' + step, true);
    })
    .catch(function(error) {
    });
  } catch (error) {
    console.error("問題が発生しました", error);
  }
}

// sessionStorage内のステップログを削除する
function clearStepLogs() {
  // sessionStorage内の全てのキーをループで確認
  for (let i = 0; i < sessionStorage.length; i++) {
    let key = sessionStorage.key(i);

    // キーが "step_logged_" で始まる場合にのみ削除
    if (key.startsWith('step_logged_')) {
      sessionStorage.removeItem(key);
    }
  }
}

window.nextPrev = nextPrev;
window.showTab = showTab;
window.validateForm = validateForm;